/* VikingsBrand — product.blade template runtime.
   Gallery swap, variant chips, engraving configurator (line-item properties +
   fee product), quantity, live ATC totals, dark sticky ATC bar, Buy it now.
   Add-to-cart itself stays on Dawn's <product-form> (AJAX + cart drawer). */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function delimit(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) number = 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    switch ((format || '${{amount}}').match(placeholderRegex)[1]) {
      case 'amount': value = delimit(cents, 2); break;
      case 'amount_no_decimals': value = delimit(cents, 0); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2);
    }
    return (format || '${{amount}}').replace(placeholderRegex, value);
  }
  function stripZeros(money) {
    return money.replace(/([.,]00)(?=\D|$)/, '');
  }
  /* shop.money_format carries HTML on this store (<span class=money>${{amount}}</span>),
     which is what the currency display hooks onto. Money must therefore be written with
     innerHTML — textContent prints the tags as literal text. */
  function setMoney(el, html) {
    if (el) el.innerHTML = html;
  }
  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function boot() {
    var root = document.querySelector('.vb-blade[data-section-id]');
    if (!root || root.dataset.bladeBooted) return;
    root.dataset.bladeBooted = 'true';

    var dataEl = root.querySelector('[data-blade-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form = document.getElementById(data.formId);
    var idInput = root.querySelector('[data-blade-variant-id]');
    var qtyInput = root.querySelector('[data-blade-qty]');
    var atcBtn = root.querySelector('[data-blade-atc]');
    var atcLabel = root.querySelector('[data-blade-atc-label]');
    var buyNow = root.querySelector('[data-blade-buynow]');
    var priceEl = root.querySelector('[data-blade-price]');
    var compareEl = root.querySelector('[data-blade-compare]');
    var saveEl = root.querySelector('[data-blade-save]');
    var saveAmtEl = root.querySelector('[data-blade-save-amt]');
    var sticky = root.querySelector('[data-blade-sticky]');
    var stickyMeta = root.querySelector('[data-blade-sticky-meta]');
    var stickyTotal = root.querySelector('[data-blade-sticky-total]');
    var anchor = root.querySelector('[data-atc-anchor]');

    var engrave = root.querySelector('[data-blade-engrave]');
    var engraveOn = false;
    var engraveText = '';
    var engravePlace = '';
    var feeVariant = engrave ? parseInt(engrave.dataset.feeVariant, 10) : 0;
    var feeCents = engrave ? parseInt(engrave.dataset.feeCents, 10) || 0 : 0;

    var currentVariant = (function () {
      var id = idInput ? parseInt(idInput.value, 10) : 0;
      return data.variants.find(function (v) { return v.id === id; }) || data.variants[0] || null;
    })();

    /* ---------- gallery ----------
       The stage is a scroll-snap track, so thumbnails and variant changes SCROLL it
       rather than rewriting a single <img> src (which left touch users with nothing
       to swipe). Everything below keeps stage / thumbs / counter in sync. */
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-blade-thumb]'));
    var track = root.querySelector('[data-blade-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-blade-slide]')) : [];
    var counterCur = root.querySelector('[data-blade-counter-cur]');
    var thumbScroll = root.querySelector('[data-blade-thumbs-scroll]');
    var thumbPrev = root.querySelector('[data-blade-thumbs-prev]');
    var thumbNext = root.querySelector('[data-blade-thumbs-next]');
    var stageIndex = 0;

    var mediaIndex = function (list, mediaId) {
      var id = String(mediaId);
      for (var i = 0; i < list.length; i++) {
        if (list[i].dataset.mediaId === id) return i;
      }
      return -1;
    };

    /* `instant` suppresses the CSS smooth scroll, used for the initial position so
       the variant's photo does not visibly slide in on load. */
    var scrollTrackTo = function (el, i, instant) {
      if (!el || !el.children[i]) return;
      var previous = el.style.scrollBehavior;
      if (instant) el.style.scrollBehavior = 'auto';
      el.scrollLeft = el.children[i].offsetLeft - el.offsetLeft;
      if (instant) el.style.scrollBehavior = previous || '';
    };

    var setStageIndex = function (i) {
      if (i < 0 || i >= slides.length) return;
      stageIndex = i;
      var id = slides[i].dataset.mediaId;
      thumbs.forEach(function (t) {
        var on = t.dataset.mediaId === id;
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (!on || !thumbScroll || thumbScroll.scrollWidth <= thumbScroll.clientWidth) return;
        var left = t.offsetLeft - thumbScroll.offsetLeft;
        var right = left + t.offsetWidth;
        if (left < thumbScroll.scrollLeft) thumbScroll.scrollLeft = left;
        else if (right > thumbScroll.scrollLeft + thumbScroll.clientWidth) {
          thumbScroll.scrollLeft = right - thumbScroll.clientWidth;
        }
      });
      if (counterCur) counterCur.textContent = String(i + 1);
    };

    var goToMedia = function (mediaId, instant) {
      var i = mediaIndex(slides, mediaId);
      if (i < 0) return;
      scrollTrackTo(track, i, instant);
      setStageIndex(i);
    };

    /* Counter and thumbnails are always derived from where the track actually sits,
       never from an index we merely intended to scroll to. */
    var syncFromScroll = function () {
      if (!track) return;
      var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
      setStageIndex(Math.min(Math.max(i, 0), slides.length - 1));
    };

    if (track) {
      var stageTick;
      track.addEventListener('scroll', function () {
        clearTimeout(stageTick);
        stageTick = setTimeout(syncFromScroll, 80);
      }, { passive: true });

      /* A rotation changes the slide width, which leaves the track parked between two
         snap points and the counter reading the wrong photo. Re-anchor on the slide
         that was showing. */
      var resizeTick;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTick);
        resizeTick = setTimeout(function () {
          scrollTrackTo(track, stageIndex, true);
          syncFromScroll();
        }, 120);
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goToMedia(t.dataset.mediaId); });
    });

    /* Land on the variant's photo, which is not always media[0]. A scroll-snap
       container discards a scroll position set before its first layout, so this is
       retried on load, but only while the track is untouched (scrollLeft 0), so it
       can never fight a swipe the customer already made. */
    var initialImg = root.querySelector('[data-blade-main-img]');
    var initialSlide = initialImg ? initialImg.closest('[data-blade-slide]') : null;
    var initialIndex = initialSlide ? mediaIndex(slides, initialSlide.dataset.mediaId) : 0;
    var applyInitialMedia = function () {
      if (track && initialIndex > 0 && track.scrollLeft === 0) scrollTrackTo(track, initialIndex, true);
      syncFromScroll();
    };
    applyInitialMedia();
    if (initialIndex > 0) window.addEventListener('load', applyInitialMedia);

    /* ---------- thumb row: swipe + arrows ---------- */
    if (thumbScroll && thumbPrev && thumbNext) {
      var updateThumbNav = function () {
        var max = thumbScroll.scrollWidth - thumbScroll.clientWidth;
        var overflowing = max > 1;
        var x = thumbScroll.scrollLeft;
        thumbPrev.hidden = !overflowing || x <= 1;
        thumbNext.hidden = !overflowing || x >= max - 1;
      };
      var stepThumbs = function (dir) {
        thumbScroll.scrollBy({ left: dir * Math.max(thumbScroll.clientWidth * 0.75, 120), behavior: 'smooth' });
      };
      thumbPrev.addEventListener('click', function () { stepThumbs(-1); });
      thumbNext.addEventListener('click', function () { stepThumbs(1); });
      thumbScroll.addEventListener('scroll', updateThumbNav, { passive: true });
      window.addEventListener('resize', updateThumbNav);
      updateThumbNav();
    }

    /* ---------- lightbox ----------
       Blade PDPs had no zoom at all. Sources sit in data-lb-* until the lightbox is
       opened, so a closed lightbox downloads nothing; only the current slide and its
       two neighbours are ever hydrated. Images are fit-to-screen (object-fit: contain)
       (pinch-zoom is what magnifies from there, instead of Dawn's fixed 1100px pan). */
    var lb = root.querySelector('[data-blade-lightbox]');
    if (lb && slides.length) {
      var lbTrack = lb.querySelector('[data-blade-lightbox-track]');
      var lbSlides = Array.prototype.slice.call(lb.querySelectorAll('[data-blade-lightbox-slide]'));
      var lbCounter = lb.querySelector('[data-blade-lightbox-counter]');
      var lbCloseBtn = lb.querySelector('[data-blade-lightbox-close]');
      var lbDialog = lb.querySelector('.vb-bl-lightbox__dialog');
      var zoomBtn = root.querySelector('[data-blade-zoom]');
      var lbIndex = 0;
      var lbOpener = null;

      var hydrate = function (i) {
        [i - 1, i, i + 1].forEach(function (n) {
          var slide = lbSlides[n];
          if (!slide) return;
          var img = slide.querySelector('img');
          if (!img || img.getAttribute('src')) return;
          if (img.dataset.lbSrcset) img.setAttribute('srcset', img.dataset.lbSrcset);
          img.setAttribute('src', img.dataset.lbSrc);
        });
      };

      var setLbIndex = function (i) {
        lbIndex = i;
        hydrate(i);
        if (lbCounter) lbCounter.textContent = i + 1 + ' / ' + lbSlides.length;
      };

      var openLb = function (i) {
        lbOpener = document.activeElement;
        lb.hidden = false;
        document.documentElement.classList.add('vb-bl-lightbox-open');
        setLbIndex(i);
        scrollTrackTo(lbTrack, i, true);
        if (lbDialog) lbDialog.focus();
      };

      var closeLb = function () {
        if (lb.hidden) return;
        lb.hidden = true;
        document.documentElement.classList.remove('vb-bl-lightbox-open');
        /* Leaving the stage on the photo the customer was last looking at. */
        goToMedia(lbSlides[lbIndex].dataset.mediaId, true);
        if (lbOpener && lbOpener.focus) lbOpener.focus();
      };

      if (zoomBtn) zoomBtn.addEventListener('click', function () { openLb(stageIndex); });
      slides.forEach(function (slide, i) {
        slide.addEventListener('click', function () { openLb(i); });
      });
      if (lbCloseBtn) lbCloseBtn.addEventListener('click', closeLb);
      lb.addEventListener('click', function (e) {
        /* Backdrop / letterbox area closes; the photo itself does not. */
        if (e.target === lb || e.target === lbDialog || e.target === lbTrack) closeLb();
        else if (e.target.hasAttribute && e.target.hasAttribute('data-blade-lightbox-slide')) closeLb();
      });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') {
          closeLb();
        } else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var next = e.key === 'ArrowRight' ? lbIndex + 1 : lbIndex - 1;
          next = Math.min(Math.max(next, 0), lbSlides.length - 1);
          scrollTrackTo(lbTrack, next);
          setLbIndex(next);
        }
      });
      if (lbTrack) {
        var lbTick;
        lbTrack.addEventListener('scroll', function () {
          clearTimeout(lbTick);
          lbTick = setTimeout(function () {
            var i = Math.round(lbTrack.scrollLeft / (lbTrack.clientWidth || 1));
            i = Math.min(Math.max(i, 0), lbSlides.length - 1);
            if (i !== lbIndex) setLbIndex(i);
          }, 80);
        }, { passive: true });
      }
    }

    /* ---------- totals / price ---------- */
    function unitCents() {
      var base = currentVariant ? currentVariant.price : 0;
      return base + (engraveActive() ? feeCents : 0);
    }
    function qty() {
      var q = parseInt(qtyInput && qtyInput.value, 10);
      return isNaN(q) || q < 1 ? 1 : q;
    }
    function engraveActive() {
      return !!(engrave && engraveOn && engraveText.trim().length > 0);
    }
    function render() {
      var available = currentVariant && currentVariant.available;
      var total = formatMoney(unitCents() * qty(), data.moneyFormat);

      if (priceEl && currentVariant) setMoney(priceEl, formatMoney(currentVariant.price, data.moneyFormat));
      var hasCompare = currentVariant && currentVariant.compareAtPrice > currentVariant.price;
      if (compareEl) {
        compareEl.hidden = !hasCompare;
        if (hasCompare) setMoney(compareEl, formatMoney(currentVariant.compareAtPrice, data.moneyFormat));
      }
      if (saveEl) {
        saveEl.hidden = !hasCompare;
        if (hasCompare && saveAmtEl) {
          setMoney(saveAmtEl, stripZeros(formatMoney(currentVariant.compareAtPrice - currentVariant.price, data.moneyFormat)));
        }
      }
      if (atcBtn && atcLabel) {
        if (!currentVariant) {
          atcBtn.disabled = true;
          atcLabel.textContent = atcBtn.dataset.labelUnavailable || 'Unavailable';
        } else if (!available) {
          atcBtn.disabled = true;
          atcLabel.textContent = atcBtn.dataset.labelSoldout || 'Sold out';
        } else {
          atcBtn.disabled = false;
          atcLabel.innerHTML = escapeHtml(atcBtn.dataset.labelAdd || 'Add to cart') + ' — ' + total;
        }
      }
      if (idInput && currentVariant) {
        idInput.value = currentVariant.id;
        idInput.disabled = !available;
      }
      if (buyNow) buyNow.disabled = !available;
      if (stickyTotal) setMoney(stickyTotal, total);
      if (stickyMeta && currentVariant && !data.hasOnlyDefaultVariant) currentVariant.title && (stickyMeta.textContent = currentVariant.title.split(' / ').join(' · '));
    }

    /* ---------- variant chips ---------- */
    var optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-blade-option]'));
    function selectedOptions() {
      return optionGroups
        .sort(function (a, b) { return a.dataset.optionIndex - b.dataset.optionIndex; })
        .map(function (g) {
          var active = g.querySelector('[data-blade-chip][aria-pressed="true"]');
          return active ? active.dataset.value : null;
        });
    }
    function matchVariant(opts) {
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      }) || null;
    }
    function updateEdgeNote(group) {
      var note = group.querySelector('[data-blade-edge-note]');
      if (!note) return;
      var active = group.querySelector('[data-blade-chip][aria-pressed="true"]');
      if (!active) return;
      var isDisplay = /display|unsharpened|blunt/i.test(active.dataset.value);
      note.textContent = isDisplay ? (note.dataset.noteDisplay || '') : (note.dataset.noteBattle || '');
    }
    function updateSheathSpec(opts) {
      var cell = root.querySelector('[data-blade-spec-sheath]');
      if (!cell) return;
      var hasSheathValue = data.variants.some(function (v) { return v.options.some(function (o) { return /sheath/i.test(o); }); });
      if (!hasSheathValue) return;
      var selectedHasSheath = opts.some(function (o) { return o && /sheath|\+ ?sheath/i.test(o) && !/only/i.test(o); });
      cell.textContent = selectedHasSheath ? cell.dataset.included : 'Not included';
    }
    optionGroups.forEach(function (group) {
      updateEdgeNote(group);
      group.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-blade-chip]');
        if (!chip) return;
        group.querySelectorAll('[data-blade-chip]').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        var sel = group.querySelector('[data-blade-opt-sel]');
        if (sel) sel.textContent = chip.dataset.value;
        updateEdgeNote(group);
        var opts = selectedOptions();
        currentVariant = matchVariant(opts);
        updateSheathSpec(opts);
        if (currentVariant) {
          if (currentVariant.mediaId) goToMedia(currentVariant.mediaId);
          try { history.replaceState(null, '', window.location.pathname + '?variant=' + currentVariant.id); } catch (err) { /* noop */ }
        }
        render();
      });
    });
    updateSheathSpec(selectedOptions());

    /* ---------- quantity ---------- */
    var down = root.querySelector('[data-blade-qty-down]');
    var up = root.querySelector('[data-blade-qty-up]');
    if (down) down.addEventListener('click', function () { qtyInput.value = Math.max(1, qty() - 1); render(); });
    if (up) up.addEventListener('click', function () { qtyInput.value = qty() + 1; render(); });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qty(); render(); });

    /* ---------- engraving ---------- */
    /* Transliteration runs through vb-runes.js (window.VBRunes), the same engine
       the rune translator uses, so the PDP preview and the translator can never
       disagree about what a name looks like in a given row.
       Button label -> map key. Latin is absent on purpose: no key means no runes. */
    var SCRIPT_KEYS = {
      'Elder Futhark': 'elder',
      'Younger Futhark': 'younger',
      'Anglo-Saxon': 'anglo'
    };
    function scriptKey(label) { return SCRIPT_KEYS[label] || null; }
    function toRunes(str, key) {
      return (window.VBRunes && key)
        ? window.VBRunes.transliterate(String(str || ''), key)
        : String(str || '');
    }

    if (engrave) {
      var toggle = engrave.querySelector('[data-blade-engrave-toggle]');
      var input = engrave.querySelector('[data-blade-engrave-input]');
      var hint = engrave.querySelector('[data-blade-engrave-hint]');
      var count = engrave.querySelector('[data-blade-engrave-count]');
      var preview = engrave.querySelector('[data-blade-engrave-preview]');
      var previewText = engrave.querySelector('[data-blade-engrave-previewtext]');
      var previewPlace = engrave.querySelector('[data-blade-engrave-previewplace]');
      var previewScript = engrave.querySelector('[data-blade-engrave-previewscript]');
      var propText = root.querySelector('[data-blade-prop-engraving]');
      var propScript = root.querySelector('[data-blade-prop-script]');
      var propPlace = root.querySelector('[data-blade-prop-placement]');
      var propRunes = root.querySelector('[data-blade-prop-runes]');
      var leadExtra = root.querySelector('[data-blade-lead-extra]');
      var placeBtns = Array.prototype.slice.call(engrave.querySelectorAll('[data-blade-place]'));
      var scriptBtns = Array.prototype.slice.call(engrave.querySelectorAll('[data-blade-script]'));
      var firstPlace = placeBtns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
      engravePlace = firstPlace ? firstPlace.dataset.value : '';
      var engraveScript = 'Latin';

      function engraveProps() {
        var p = {
          'Engraving': engraveText.trim(),
          'Script': engraveScript,
          'Engraving placement': engravePlace
        };
        var propKey = scriptKey(engraveScript);
        if (propKey) p['Engraving runes'] = toRunes(engraveText.trim(), propKey);
        return p;
      }
      root.bladeEngraveProps = engraveProps;

      function renderEngrave() {
        engrave.dataset.on = engraveOn ? 'true' : 'false';
        if (toggle) toggle.setAttribute('aria-expanded', engraveOn ? 'true' : 'false');
        var text = engraveText.trim();
        var runeKey = scriptKey(engraveScript);
        var isFuthark = !!runeKey;
        /* Max comes off the input's own maxlength so the counter can never
           drift from the real limit again. */
        var engraveMax = (input && input.getAttribute('maxlength')) || '60';
        if (count) count.textContent = engraveText.length + ' / ' + engraveMax;
        if (hint) {
          hint.dataset.filled = text.length > 0 ? 'true' : 'false';
          hint.textContent = text.length > 0 ? (isFuthark ? hint.dataset.hintFuthark : hint.dataset.hintLatin) : hint.dataset.hintEmpty;
        }
        var show = engraveOn && text.length > 0;
        if (preview) preview.hidden = !show;
        if (previewText) {
          previewText.textContent = isFuthark ? toRunes(text, runeKey) : text.toUpperCase();
          previewText.classList.toggle('vb-bl-engrave__previewtext--runic', isFuthark);
        }
        if (previewPlace) previewPlace.textContent = engravePlace;
        if (previewScript) previewScript.textContent = engraveScript;
        var active = engraveActive();
        /* Raw text as typed = source of truth for the smith; runes only when Futhark. */
        if (propText) { propText.disabled = !active; propText.value = text; }
        if (propScript) { propScript.disabled = !active; propScript.value = engraveScript; }
        if (propPlace) { propPlace.disabled = !active; propPlace.value = engravePlace; }
        if (propRunes) {
          /* Key resolved here rather than reused from renderEngrave: this runs in a
             sibling function, and the runes carried into the cart are what the smith
             actually cuts, so it must not depend on another function's locals. */
          var cartKey = scriptKey(engraveScript);
          var sendRunes = active && !!cartKey;
          propRunes.disabled = !sendRunes;
          propRunes.value = sendRunes ? toRunes(text, cartKey) : '';
        }
        if (leadExtra) leadExtra.hidden = !active;
        render();
      }
      if (toggle) toggle.addEventListener('click', function () { engraveOn = !engraveOn; renderEngrave(); });
      if (input) input.addEventListener('input', function () {
        /* Cap from the input's own maxlength, not a literal, so raising the
           limit in the markup is enough and this never silently overrides it. */
        var max = parseInt(input.getAttribute('maxlength'), 10) || 60;
        engraveText = input.value.slice(0, max);
        input.value = engraveText;
        renderEngrave();
      });
      placeBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          placeBtns.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          engravePlace = b.dataset.value;
          renderEngrave();
        });
      });
      scriptBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          scriptBtns.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          engraveScript = b.dataset.value;
          renderEngrave();
        });
      });
      renderEngrave();

      /* Add the engraving fee product BEFORE Dawn's product-form submit, so the
         drawer refresh after the main add shows both lines. Runs at document
         capture phase, ahead of product-form.js's own submit handler. */
      var feePending = false;
      document.addEventListener('submit', function (e) {
        if (e.target !== form || !engraveActive() || !feeVariant || feePending) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        feePending = true;
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: feeVariant,
              quantity: qty(),
              properties: root.bladeEngraveProps ? root.bladeEngraveProps() : {}
            }]
          })
        }).catch(function () { /* fee add failed — still add the blade */ }).then(function () {
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
          setTimeout(function () { feePending = false; }, 500);
        });
      }, true);
    }

    /* ---------- buy it now ---------- */
    if (buyNow) {
      buyNow.addEventListener('click', function () {
        if (!currentVariant || buyNow.getAttribute('aria-busy') === 'true') return;
        buyNow.setAttribute('aria-busy', 'true');
        var items = [];
        if (engraveActive() && feeVariant) {
          items.push({ id: feeVariant, quantity: qty(), properties: root.bladeEngraveProps ? root.bladeEngraveProps() : {} });
        }
        var main = { id: currentVariant.id, quantity: qty() };
        if (engraveActive() && root.bladeEngraveProps) main.properties = root.bladeEngraveProps();
        items.push(main);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        }).catch(function () {
          buyNow.removeAttribute('aria-busy');
          if (atcBtn && !atcBtn.disabled) atcBtn.click();
        });
      });
    }

    /* ---------- sticky bar ---------- */
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var show = !e.isIntersecting && e.boundingClientRect.bottom < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(anchor);
      var stickyAdd = sticky.querySelector('[data-blade-sticky-add]');
      if (stickyAdd) {
        stickyAdd.addEventListener('click', function () {
          if (atcBtn && !atcBtn.disabled) atcBtn.click();
        });
      }
    }

    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
